<div class="w-full h-full">
  <canvas #canvas></canvas>
  <div class="zoom-help-dialog-host"></div>
</div>
